import { render, staticRenderFns } from "./HighlightAlaCarteMenu.vue?vue&type=template&id=2146039d&scoped=true&"
import script from "./HighlightAlaCarteMenu.vue?vue&type=script&lang=js&"
export * from "./HighlightAlaCarteMenu.vue?vue&type=script&lang=js&"
import style0 from "./HighlightAlaCarteMenu.vue?vue&type=style&index=0&id=2146039d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2146039d",
  null
  
)

export default component.exports